import Model from "@/lib/model/model";

export default class PostPolicy extends Model {
  accessid = "";
  dir = "";
  expire = 0;
  host = "";
  cdn = "";
  policy = "";
  signature = "";
}
